import * as React from "react";
import { ResponsiveSheet } from "./ResponsiveSheet";
import type { DailyTimelineLabels } from "./types";

interface CancelReasonSheetProps {
  open: boolean;
  labels: DailyTimelineLabels;
  onClose: () => void;
  onConfirm: (reason: string) => void;
}

export function CancelReasonSheet({ open, labels, onClose, onConfirm }: CancelReasonSheetProps) {
  const [reason, setReason] = React.useState("");

  React.useEffect(() => {
    if (!open) setReason("");
  }, [open]);

  return (
    <ResponsiveSheet
      open={open}
      onClose={onClose}
      title={labels.cancelReasonTitle}
      closeLabel={labels.closeSheet}
      footer={
        <div className="flex gap-2 justify-end">
          <button
            type="button"
            onClick={onClose}
            className="h-12 px-4 rounded-biz-btn text-sm font-semibold border border-biz-border text-biz-foreground hover:bg-biz-muted biz-focus-ring biz-motion-safe transition-colors"
          >
            {labels.cancelReasonDismiss}
          </button>
          <button
            type="button"
            onClick={() => onConfirm(reason.trim())}
            className="h-12 px-4 rounded-biz-btn text-sm font-semibold bg-biz-danger text-biz-danger-foreground hover:opacity-90 biz-focus-ring biz-motion-safe transition-opacity"
          >
            {labels.cancelReasonConfirm}
          </button>
        </div>
      }
    >
      <label className="block text-xs font-semibold uppercase tracking-wider text-biz-foreground-muted mb-2">
        {labels.cancelReasonTitle}
      </label>
      <textarea
        value={reason}
        onChange={(e) => setReason(e.target.value)}
        placeholder={labels.cancelReasonPlaceholder}
        rows={4}
        className="w-full rounded-biz-btn border border-biz-border bg-biz-bg text-biz-foreground p-3 text-sm biz-focus-ring resize-none"
      />
    </ResponsiveSheet>
  );
}
